module.exports = __webpack_public_path__ + "assets/img/loyalty-1.44c18b7a.svg";